import { IExtendableDto, SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";

export class FeedbackApi {
  static async sendToSupplier(
    feedbackId: number,
  ): Promise<SimpleResult<IExtendableDto> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/feedbacks/send_to_supplier/${feedbackId}`;
    const response = await Api.post<SimpleResult<IExtendableDto>>(requestUrl);
    return response?.data;
  }

  static async sendSupplierResponse(
    feedbackId: number,
  ): Promise<SimpleResult<IExtendableDto> | undefined> {
    const companyId = getCompanyId();
    const requestUrl = `/api/v1/core/c/${companyId}/feedbacks/send_supplier_response/${feedbackId}`;
    const response = await Api.post<SimpleResult<IExtendableDto>>(requestUrl);
    return response?.data;
  }
}
